import { makeStyles, lighten, darken } from "@material-ui/core";

const hOffsetRem = "0.75";

// Buttons
export const BQSButtonStyle = makeStyles((theme) => ({
    root: {
        backgroundColor: "#C12631",
        color: "white",
        fontSize: "1rem",
        margin: `0 ${hOffsetRem}rem`,
        padding: "6px 18px",
        "&:hover": {
            backgroundColor: lighten("#C12631", 0.2),
        },
    },
}));

// CheckBoxes
export const BQSCheckBoxesStyle = makeStyles((theme) => ({
    root: {
        margin: `0.5rem -${hOffsetRem}rem`,
        "& legend": {
            margin: `0 ${hOffsetRem}rem 0.5rem ${hOffsetRem}rem`,
        },
    },
}));

export const BQSCheckBoxStyle = makeStyles((theme) => ({
    root: {
        margin: `0 ${hOffsetRem}rem 0 0`,
        "& .MuiCheckbox-root": {
            padding: "6px 9px",
        },
    },
}));

// Edits
export const BQSEditNumberStyle = makeStyles((theme) => ({
    root: {
        margin: `0.5rem ${hOffsetRem}rem`,
        "& label": {},
        "& label.MuiInputLabel-shrink": {
            transform: "translate(0, 0) scale(1)",
        },
        "& div.MuiInput-root": {
            marginTop: "1.5rem",
        },
        "& input.MuiInput-input": {
            backgroundColor: "white",
            border: "1px solid #5F5D5E",
            padding: "5px 8px 3px 8px",
        },
    },
}));

export const BQSEditStyle = makeStyles((theme) => ({
    root: {
        margin: `0.5rem ${hOffsetRem}rem`,
        "& label": {},
        "& label.MuiInputLabel-shrink": {
            transform: "translate(0, 0) scale(1)",
        },
        "& div.MuiInput-root": {
            marginTop: "1.5rem",
        },
        "& input.MuiInput-input": {
            backgroundColor: "white",
            border: "1px solid #5F5D5E",
            padding: "5px 8px 3px 8px",
        },
    },
}));

// Radio Buttons
export const BQSRadioButtonsStyle = makeStyles((theme) => ({
    root: {
        margin: `0.5rem -${hOffsetRem}rem`,
        "& legend": {
            margin: `0 ${hOffsetRem}rem 0.5rem ${hOffsetRem}rem`,
        },
    },
}));

export const BQSRadioButtonStyle = makeStyles((theme) => ({
    root: {
        margin: `0 ${hOffsetRem}rem 0 0`,
        "& .MuiRadio-root": {
            padding: "6px 9px",
        },
    },
}));

// Rows
export const BQSRowStyle = makeStyles((theme) => ({
    root: {
        margin: `0 -${hOffsetRem}rem`,
    },
}));

// Selects
export const BQSSelectStyle = makeStyles((theme) => ({
    root: {
        margin: `0.5rem ${hOffsetRem}rem`,
        "& label": {},
        "& label.MuiInputLabel-shrink": {
            transform: "translate(0, 0) scale(1)",
        },
        "& div.MuiInput-root": {
            backgroundColor: "white",
            border: "1px solid #5F5D5E",
            marginTop: "1.5rem",
        },
        "& input.MuiAutocomplete-input": {
            padding: "5px 8px 3px 8px !important",
        },
    },
}));
